import React from 'react'
import { Box, Divider, Paper, Typography } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

interface DialogInfoProps {
  editMode: boolean
}

const bulletItems = [
  'Si existe un error en el archivo, toda la carga se invalidará.',
  'Revise el estado del proceso en el menú procesos.',
  'Verifique que almacén, zona, tipo de posición y estado correspondan a la información a cargar.',
  'Esta acción no puede deshacerse.'
]

export const DialogInfo: React.FC<DialogInfoProps> = ({ editMode }) => (
  <Paper
    variant='outlined'
    sx={{
      borderColor: 'error.light',
      backgroundColor: '#fff5f5',
      borderRadius: 2,
      p: 2,
      height: '100%'
    }}
  >
    <Box display='flex' alignItems='center' gap={1.5} mb={1.5}>
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          backgroundColor: 'error.main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0
        }}
      >
        <ErrorOutlineIcon sx={{ color: '#fff', fontSize: 20 }} />
      </Box>
      <Typography variant='subtitle1' fontWeight={700} color='error.main'>
        IMPORTANTE:
      </Typography>
    </Box>

    <Typography variant='caption' color='error.main' mb={2}>
      {`Recuerde que esta acción ${editMode ? 'editará' : 'creará'} posiciones masivamente según la información contenida en el archivo.`}
    </Typography>

    <Divider sx={{ borderColor: 'error.light', mb: 2 }} />

    <Box component='ul' sx={{ m: 0, pl: 2.5 }}>
      {bulletItems.map((item, i) => (
        <Typography key={i} component='li' variant='caption' color='error.main' mb={1}>
          {item}
        </Typography>
      ))}
    </Box>
  </Paper>
)
